import {toUiMsg$} from '@/ui';
import {toWsMsg$, wsOpened$} from '@/ws';
import {spotMarket24hRealtime$} from './market-spot';
import {spotMarketCache$} from './market24h-spot-cache';
import {SpotMarket} from '@/types';

export interface UMarketSpot {
  type: 'market24h-spot';
  data: Map<string, SpotMarket>;
}
export interface UMarketSpotRealtime {
  type: 'market24h-spot-realtime';
  data: SpotMarket;
}

export function subscribeMarketSpot() {
  wsOpened$.subscribe(() => toWsMsg$.next({method: 'spot_market24h_pack.subscribe', params: []}));

  spotMarketCache$.subscribe((data) => toUiMsg$.next({type: 'market24h-spot', data}));
  spotMarket24hRealtime$.subscribe((data) => toUiMsg$.next({type: 'market24h-spot-realtime', data}));
}
